export default "__VITE_ASSET__0yC_EJ1a__"